import { QueryAggregator } from "@/api/utils/QueryAggregator"
import { FreshdeskService } from "@/services/FreshdeskService"
import { FreshdeskTicket } from "@/models/freshdeskTicket/freshdeskTicket"
import { legacyFreshdeskGroupNameMap } from "../models/freshdeskTicket/freshdeskHelper"

class ProcessedFreshdeskTicket extends FreshdeskTicket {
  groupName?: string

  constructor(
    groupName?: string,
    ...args: ConstructorParameters<typeof FreshdeskTicket>
  ) {
    super(...args)
    this.groupName = groupName
  }
}

export const getLegacyFreshdeskTickets = (accountNumber: string) => {
  const queries = new QueryAggregator()
  const freshdeskContactQuery =
    FreshdeskService.getLegacyContacts(accountNumber)

  queries.add(freshdeskContactQuery)

  if (!freshdeskContactQuery.data || freshdeskContactQuery.data.length === 0) {
    return queries.setData([]).getAggregate()
  }

  const ticketQueries = freshdeskContactQuery.data.map((contactId) =>
    FreshdeskService.getLegacyTickets(contactId),
  )

  ticketQueries.forEach((query) => queries.add(query))

  const allTickets = ticketQueries.flatMap((query) => query.data || [])

  const getGroupName = (id: number) =>
    legacyFreshdeskGroupNameMap[id] ?? "unknown"

  const processedTickets = allTickets.map((ticket) => {
    return new ProcessedFreshdeskTicket(
      getGroupName(ticket.groupId),
      ticket.id,
      ticket.type,
      ticket.createdDate,
      ticket.updatedDate,
      ticket.subject,
      ticket.source,
      ticket.statusCode,
      ticket.groupId,
      ticket.isSpam,
      ticket.thread,
    )
  })

  return queries.setData(processedTickets).getAggregate()
}
